import { render, staticRenderFns } from "./footer-web.vue?vue&type=template&id=88f09ca8&scoped=true"
import script from "./footer-web.vue?vue&type=script&lang=js"
export * from "./footer-web.vue?vue&type=script&lang=js"
import style0 from "./footer-web.vue?vue&type=style&index=0&id=88f09ca8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f09ca8",
  null
  
)

export default component.exports